<template>
    <div class="h-100 ">
        <v-row no-gutters>
            <v-col cols="auto" class="mr-6">
                <v-btn
                        style="padding: 0; margin: 0; min-width: 40px; height: 40px"
                        outlined
                        @click="hideDetails(false)"
                        color="#ACB7C0"
                >
                    <span><v-icon >mdi-arrow-left</v-icon></span>
                </v-btn>
            </v-col>
            <v-col cols="auto" class="mr-4">
                <v-avatar size="40" color="var(--color-4)">
                    <img v-if="item.smallLogo!=null"
                            :src="$root.docsUrl+item.smallLogo"
                            alt="Лого"
                    >
                    <span v-else><v-icon>mdi-image</v-icon></span>
                </v-avatar>
            </v-col>
            <v-col class="py-1">
                <span>{{item.orgName}}</span>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
        <v-tabs
                class="custom-tabs"
                v-model="selectedTab"
                hide-slider
                show-arrows
        >
            <v-tab >
                Данные
            </v-tab>
            <v-tab  >
                Филиалы
            </v-tab>
            <v-tab >
                Сотрудники
            </v-tab>
            <v-tab >
                Акции
            </v-tab>
            <v-tab >
                История активаций
            </v-tab>
            <v-tab>
                Сетка партнеров
            </v-tab>
        </v-tabs>
        <v-tabs-items class="partner-tab-items" v-model="selectedTab" >
            <v-tab-item  class="h-100">
                <mainDataInfo class="h-100" :item="item" @hideDetails="hideDetails"></mainDataInfo>
            </v-tab-item>
            <v-tab-item class="h-100">
                <infoBranches class="h-100" :item="item"></infoBranches>
            </v-tab-item>
            <v-tab-item class="h-100">
                <infoStaff class="h-100" :item="item"></infoStaff>
            </v-tab-item>
            <v-tab-item class="h-100">
                <infoStocks class="h-100" :item="item"></infoStocks>
            </v-tab-item>
            <v-tab-item class="h-100">
                <infoActivates class="h-100" :item="item"></infoActivates>
            </v-tab-item>
            <v-tab-item class="h-100">
                <infoGrid class="h-100" :item="item"></infoGrid>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
    const mainDataInfo =()=>import('./PartnerInfoData')
    const infoBranches =()=>import( './PartnerInfoBranches')
    const infoStaff =()=>import( './PartnerInfoStaff')
    const infoStocks =()=>import( './PartnerInfoStocks')
    const infoActivates =()=>import( './PartnerInfoActivates')
    const infoGrid =() => import('./PartnerInfoGrid')

    export default {
        name: "PartnerInfo",
        props:["item"],
        components:{
            mainDataInfo,
            infoBranches,
            infoStaff,
            infoActivates,
            infoStocks,
            infoGrid,
        },
        data(){
            return {
                selectedTab:null,
            }
        },
        computed:{

        },
        methods:{
            hideDetails(isSave){
              this.$emit("hideDetails", isSave)

            },
            validateModel() {
                var noError = true;
                this.errors = [];
                if (this.editModel.orgName == null||this.editModel.orgName == '') {
                    this.errors.push({key: "orgName", mes: "Необходимо указать название!"});
                    noError = false;
                }
                return noError;
            },

        },
        watch:{
            item(value){
                console.log(value)
            }
        }

    }
</script>

<style >

    .partner-tab-items{
        height: calc(100% - 88px);
    }
    .partner-tab-items.v-window.v-item-group.theme--light.v-tabs-items >.v-window__container {
        height: 100% !important;
    }


</style>